/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown>, actions: NonNullable<unknown> }} Seo_Api_Opening_OneInputs */

const en_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The AnyAPI ${i?.name} API returns ${i?.name} data as normalized JSON across ${i?.count} endpoint: ${i?.actions}.`)
};

const zh_hans1_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 的 ${i?.name} API 以统一格式的 JSON 返回 ${i?.name} 数据，共 ${i?.count} 个接口：${i?.actions}。`)
};

const pt_br2_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A API da AnyAPI para ${i?.name} retorna dados de ${i?.name} em JSON normalizado, em ${i?.count} endpoint: ${i?.actions}.`)
};

const es_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La API de ${i?.name} de AnyAPI devuelve datos de ${i?.name} como JSON normalizado a través de ${i?.count} endpoint: ${i?.actions}.`)
};

const fr_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L’API ${i?.name} d’AnyAPI renvoie des données ${i?.name} en JSON normalisé via ${i?.count} endpoint : ${i?.actions}.`)
};

const de_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die AnyAPI-${i?.name}-API liefert ${i?.name}-Daten als normalisiertes JSON über ${i?.count} Endpoint: ${i?.actions}.`)
};

const ru_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI ${i?.name} API отдаёт данные ${i?.name} в виде нормализованного JSON через ${i?.count} эндпоинт: ${i?.actions}.`)
};

const it_seo_api_opening_one = /** @type {(inputs: Seo_Api_Opening_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'API ${i?.name} di AnyAPI restituisce i dati di ${i?.name} come JSON normalizzato su ${i?.count} endpoint: ${i?.actions}.`)
};

/**
* | output |
* | --- |
* | "The AnyAPI {name} API returns {name} data as normalized JSON across {count} endpoint: {actions}." |
*
* @param {Seo_Api_Opening_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_opening_one = /** @type {((inputs: Seo_Api_Opening_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_Opening_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_opening_one(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_opening_one(inputs)
	if (locale === "es") return es_seo_api_opening_one(inputs)
	if (locale === "fr") return fr_seo_api_opening_one(inputs)
	if (locale === "de") return de_seo_api_opening_one(inputs)
	if (locale === "ru") return ru_seo_api_opening_one(inputs)
	if (locale === "it") return it_seo_api_opening_one(inputs)
	return en_seo_api_opening_one(inputs)
});